import React, { useEffect } from 'react';
import { mostrarPaisesSinoEsta } from '../../redux/reducers/paisesReducers';
import {FormControl, InputLabel} from "@mui/material";
import {SelectSmart} from "../CustomTextField";
import Strings from "../../assets/strings";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";

type Props = {
    value?:number | string
    name?:string
    label?:string
    onChange?:(e:React.ChangeEvent<HTMLInputElement>)=>void
    display?: "paiCodigo" | "descripcion" | "nacionalidad"
    idAs?: "id" | "paiCodigo"
    required?:boolean
}




function SelectPais({ value, label="",name="paisIdNacionalidad", idAs="id", display="nacionalidad", onChange, required}:Props) {

    const dispatch = useAppDispatch();
    const paises = useAppSelector(state => state.paises);

    useEffect(() => {
        dispatch(mostrarPaisesSinoEsta())
    }, [dispatch]);

    let options:any[] = (paises.list && paises.list.map(opc=>({key:opc[idAs],value:opc[display]??""}))) || [];
    options.unshift({key:undefined,value:Strings.seleccione});



    if(!onChange){
        let opcion = options.find(o=>o.key === value)
        if(opcion) return  <>{opcion.value}</>;
        return <>-</>
    }

    return (

        <FormControl fullWidth required={required}>
            <InputLabel shrink>{label}</InputLabel>
            <SelectSmart
                value={value??""}
                onChange={onChange}
                name={name}
                loading={paises.status === "loading" }
                opciones={options}
            />
        </FormControl>

    );
}

export default SelectPais;
